import { render, staticRenderFns } from "./StartShiftPage.vue?vue&type=template&id=67490a54&scoped=true&"
import script from "./StartShiftPage.vue?vue&type=script&lang=js&"
export * from "./StartShiftPage.vue?vue&type=script&lang=js&"
import style0 from "./StartShiftPage.vue?vue&type=style&index=0&id=67490a54&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67490a54",
  null
  
)

export default component.exports